import { render, staticRenderFns } from "./btc.vue?vue&type=template&id=718dc01d&"
import script from "./btc.vue?vue&type=script&lang=js&"
export * from "./btc.vue?vue&type=script&lang=js&"
import style0 from "./btc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports